/* eslint-disable no-dupe-keys */
import authSlice from "./authSlice";
import UserSlice from "./userSlice";
import AthleteSlice from "./AthleteSlice";
import OrderSlice from "./OrderSlice";
import DisciplineSlice from "./DisciplineSlice";
import InterestSlice from "./InterestSlice";
import NotificationSlice from "./NotificationSlice";
import CommissionSlice from "./CommissionSlice";
import EnumsSlice from "./EnumsSlice";
export const rootReducer = {
  Auth: authSlice,
  UserReducer: UserSlice,
  OrderReducer: OrderSlice,
  AthleteReducer: AthleteSlice,
  DisciplineReducer: DisciplineSlice,
  InterestReducer: InterestSlice,
  Notifications: NotificationSlice,
  CommissionReducer: CommissionSlice,
  Enums: EnumsSlice
};
